import alpha from '../assets/icons/alpha.svg';
import wal from '../assets/icons/WAL.svg';
import sui from '../assets/icons/sui.svg';
import alphaLend from '../assets/icons/alphalendIcon.svg';
import bluefin from '../assets/icons/bluefin.svg';
import stsui from '../assets/icons/stsui.svg';
import hasui from '../assets/icons/hasui.svg';
import navi from '../assets/icons/NaviToken.svg';
import suiusdt from '../assets/icons/suiUSDT.svg';
import bucket from '../assets/icons/bucket_protocol.svg';
import wusdc from '../assets/icons/wusdc.svg';
import cetus from '../assets/icons/cetus_token.svg';
import usdc from '../assets/icons/USDC.svg';
import success from '../assets/icons/success.svg';
import failed from '../assets/icons/failed.svg';
import eth from '../assets/icons/ETH.svg';
import btc from '../assets/icons/wbtc.svg';
// import wbtc from '../assets/icons/wbtc.svg';
import wbtcIcon from '../assets/icons/wBTC_icon.svg';
import suibtc from '../assets/icons/suibtc.svg';
import usdt from '../assets/icons/usdt.svg';
import usdy from '../assets/icons/usdy.svg';
import afsui from '../assets/icons/afsui.svg';
import alkimi from '../assets/icons/alkimi.png';
import esui from '../assets/icons/egSUI.svg';
import ebtc from '../assets/icons/eBTC.svg';
import xbtc from '../assets/icons/xBTC.svg';
import xaum from '../assets/icons/XAUm.svg';
import up from '../assets/icons/Up.svg';
import wsol from '../assets/icons/SOL.svg';
import deep from '../assets/icons/deep.svg';
import fud from '../assets/icons/FUD.svg';
import ausd from '../assets/icons/AUSD.svg';
import ns from '../assets/icons/ns.svg';
import blue from '../assets/icons/bluefin.svg';
import send from '../assets/icons/SEND.svg';
import dmc from '../assets/icons/dmc.svg';
import ika from '../assets/icons/IKA.svg';
import tbtc from '../assets/icons/tBTC.svg';
import lbtc from '../assets/icons/LBTC.svg';
import musd from '../assets/icons/musdIcon.svg';
import vsui from '../assets/icons/vSUI.svg';
import scallop from '../assets/icons/scallop_token.svg';
import egusdc from '../assets/icons/egUSDC.svg';
import ethird from '../assets/icons/eTHIRD.png';
import suieth from '../assets/icons/suiETH.svg';
import exbtc from '../assets/icons/exBTC.png';
import ewal from '../assets/icons/ewal.png';
import refreshIcon from '../assets/icons/rewardRefresh.svg';
import lockIcon from '../assets/icons/lock.svg';
import menuIcon from '../assets/icons/menu_icon.svg';
import closeIcon from '../assets/icons/blue_close_icon.png';
import redirectImage from '../assets/icons/redirectIcon.svg';
import redirectHover from '../assets/icons/redirectHover.svg';
import rightArrowWhite from '../assets/icons/white_right_arrow.svg';
import questionMark from '../assets/icons/questionIcon.png';
import externalLinkIcon from '../assets/icons/externalLinkIcon.svg';
import docsIcon from '../assets/icons/docs.svg';
import websiteIcon from '../assets/icons/website.svg';
import contractIcon from '../assets/icons/contract.svg';
import roundedGreenCheckIcon from '../assets/icons/roundedGreenCheck.svg';
import flagIcon from '../assets/icons/flag.svg';
import timeIcon from '../assets/icons/Time.svg';
import cancelIcon from '../assets/icons/noRoundIcon.png';
import roundedGrayCheckIcon from '../assets/icons/roundGreyCheck.svg';
import warningIcon from '../assets/icons/warning.svg';
import airdropModalCloseIcon from '../assets/icons/airdropCloseIcon.svg';
// Theme icons
import darkThemeCloseIcon from '../assets/icons/darkThemeCloseIcon.svg';
import darkSun from '../assets/icons/darkSun.svg';
import darkMoon from '../assets/icons/darkMoon.svg';
import whiteSun from '../assets/icons/whiteSun.svg';
import whiteMoon from '../assets/icons/whiteMoon.svg';
import darkThreeDotIcon from '../assets/icons/blackThreeDots.svg';
import whiteThreeDotIcon from '../assets/icons/whiteThreeDots.svg';
// Social media icons
import twitter from '../assets/icons/twitter.svg';
import telegram from '../assets/icons/telegram.svg';
import medium from '../assets/icons/medium.svg';
import whiteTwitter from '../assets/icons/whiteTwitter.svg';
import whiteTelegram from '../assets/icons/whiteTelegram.svg';
import whiteTelegramIcon from '../assets/icons/whiteTelegramIcon.svg';
import whiteMedium from '../assets/icons/whiteMedium.svg';
import darkThemeTwitter from '../assets/icons/darkThemeTwitter.svg';
import darkThemeTelegram from '../assets/icons/darkThemeTelegram.svg';
import darkThemeMedium from '../assets/icons/darkThemeMedium.svg';
import twitterHoverFooter from '../assets/icons/twitter_hover_footer.svg';
import telegramHoverFooter from '../assets/icons/telegram_hover_footer.svg';
import mediumHoverFooter from '../assets/icons/medium_hover_footer.svg';
import discordHoverFooter from '../assets/icons/Discord_hover_footer.svg';
import twitterFooter from '../assets/icons/twitter_footer.svg';
import telegramFooter from '../assets/icons/telegram_footer.svg';
import mediumFooter from '../assets/icons/medium_footer.svg';
import discordFooter from '../assets/icons/discord_footer.svg';
// Footer audit/security icons
import movebitIcon from '../assets/icons/movebit.png';
import zeroShadowIcon from '../assets/icons/zero_shadow.png';
// Navigation icons
import darkThemeRightArrow from '../assets/icons/darkThemeRightArrow.svg';
import upArrowBlack from '../assets/icons/upArrowBlack.svg';
import downArrowBlack from '../assets/icons/downArrowBlack.svg';
import defaultArrow from '../assets/icons/downArrowDefault.svg';
import darkThemeDefaultArrow from '../assets/icons/darkThemeDefaultArrow.svg';
import darkThemeDownArrow from '../assets/icons/darkThemeDownArrow.svg';
import darkThemeUpArrow from '../assets/icons/darkThemeUpArrow.svg';
import externalIconDark from '../assets/icons/externalLinkIcon.svg';
import externalIconWhite from '../assets/icons/externalLinkDarkIcon.svg';
import externalIcon from '../assets/icons/redirectIcon.svg';
import externalIconHover from '../assets/icons/redirectHover.svg';
import defaultArrowDown from '../assets/icons/defaultArrowDown.svg';
// Wallet icons
import addressCopyIcon from '../assets/icons/copy_icon.svg';
import addressExternalLink from '../assets/icons/redirectHover.svg';
import disconnectFilledIcon from '../assets/icons/disconnectWalletIcon.svg';
import walletIcon from '../assets/icons/wallet_icon.svg';
import walletUpArrow from '../assets/icons/walletUpArrow.svg';
import walletDownArrow from '../assets/icons/walletDownArrow.svg';
import addressCopyIconHover from '../assets/icons/addressCopyIcon.svg';
import disconnectWalletIcon from '../assets/icons/disconnectIcon.svg';
// Arrow icons
import rightArrow from '../assets/icons/rightArrow.svg';
import downArrow from '../assets/icons/downArrow.svg';
import searchIcon from '../assets/icons/search.png';
import clearSearchIcon from '../assets/icons/clearSearch.png';
import swapRefreshIcon from '../assets/icons/refreshIcon.png';
import swapIcon from '../assets/icons/swapIcon.svg';
// Additional icons
import closeIconSvg from '../assets/icons/closeIcon.svg';
import menuIconSvg from '../assets/icons/menuIcon.svg';
import slippageIcon from '../assets/icons/slippageIcon.svg';
import secondaryCopyIcon from '../assets/icons/copy2.svg';
// Logo icons
import alphafiLogo from '../assets/icons/alphafiLogo.svg';
import alphafiLogoWhite from '../assets/icons/alphafiDarkLogo.svg';
// Theme icons
import whiteMenuIcon from '../assets/icons/whiteMenu.svg';
import blackMenuIcon from '../assets/icons/blackMenu.svg';
import darkThemeSearchIcon from '../assets/icons/darkThemeSearchIcon.svg';
import defaultThemeSearchIcon from '../assets/icons/defaultThemeSearchIcon.svg';
import whiteExternalLinkIcon from '../assets/icons/whiteExternalIcon.svg';
import blackExternalLinkIcon from '../assets/icons/blackExternalIcon.svg';
import whiteHeaderDownArrowIcon from '../assets/icons/whiteHeaderDownArrow.svg';
import whiteCopyIcon from '../assets/icons/copyIconWhite.svg';
import darkCloseIcon from '../assets/icons/darkCrossIcon.svg';
import whiteCloseIcon from '../assets/icons/whiteCloseIcon.svg';
import blackCloseIcon from '../assets/icons/blackCloseIcon.svg';
import whiteReloadIcon from '../assets/icons/whiteReloadIcon.svg';
import blackReloadIcon from '../assets/icons/blackReloadIcon.svg';
import whiteSlippageIcon from '../assets/icons/whiteSlippageIcon.svg';
import blackSlippageIcon from '../assets/icons/blackSlippageIcon.svg';
import blackSwapIcon from '../assets/icons/blackSwapIcon.svg';
import whiteSwapIcon from '../assets/icons/whiteSwapIcon.svg';
import whiteSwapButton from '../assets/icons/whiteSwapButton.svg';
import blackSwapButton from '../assets/icons/blackSwapButton.svg';
import blackDownArrow from '../assets/icons/blackDownArrow.svg';
import whiteDownArrow from '../assets/icons/whiteDownArrow.svg';
import lightWalletIcon from '../assets/icons/lightWalletIcon.svg';
import darkWalletIcon from '../assets/icons/darkWalletIcon.svg';
import viceVersaIconWhite from '../assets/icons/viceVersaIconWhite.svg';
import viceVersaIconBlack from '../assets/icons/viceVersaIconBlack.svg';
import whiteBackIcon from '../assets/icons/whiteBackIcon.svg';
import blackBackIcon from '../assets/icons/blackBackIcon.svg';
import infoIcon from '../assets/icons/infoIcon.svg';
import websiteWhite from '../assets/icons/websiteWhite.svg';
import contractWhite from '../assets/icons/contractWhite.svg';
import docsWhite from '../assets/icons/docsWhite.svg';
import whiteRefreshIcon from '../assets/icons/whiteRefreshIcon.svg';
import searchDark from '../assets/icons/searchDark.svg';
import questionMarkIcon from '../assets/icons/questionMarkIcon.svg';
import backWhiteIcon from '../assets/icons/backWhite.svg';
import backWhiteMobileIcon from '../assets/icons/backWhiteMobile.svg';
import backBlackIcon from '../assets/icons/backBlack.svg';
import backBlackMobileIcon from '../assets/icons/backBlackMobile.svg';
import zapInIcon from '../assets/icons/zapIcon.svg';
import zapInIconDarkTheme from '../assets/icons/zapIconDarkTheme.svg';
import depositsIcon from '../assets/icons/depositsIcon.svg';
import reverseTokensIcon from '../assets/icons/reverseTokensIcon.svg';
import zapSlippageIcon from '../assets/icons/zapSlippageIcon.svg';
import switchTokenIcon from '../assets/icons/switchToken.svg';
import switchTokenDarkThemeIcon from '../assets/icons/switchTokenDarkTheme.svg';
import reverseTokensIconDarkTheme from '../assets/icons/reverseTokensIconDarkTheme.svg';
import depositsIconForDarkTheme from '../assets/icons/depositsIconForDarkTheme.svg';
import swapDesktopWhiteIcon from '../assets/icons/swapDesktopWhiteIcon.svg';
import swapDesktopBlackIcon from '../assets/icons/swapDesktopBlackIcon.svg';
import plusIcon from '../assets/icons/Plus.svg';
import minusIcon from '../assets/icons/Minus.svg';
import expandIcon from '../assets/icons/expandIcon.svg';
import shrinkIcon from '../assets/icons/shrinkIcon.svg';
import darkShrinkIcon from '../assets/icons/darkShrinkIcon.svg';
import darkThemeExpandIcon from '../assets/icons/darkThemeExpand.svg';
import alphaIconForLightTheme from '../assets/icons/alpha_dark_icon.svg';
const iconMap = {
    usdy: usdy,
    wal: wal,
    sui: sui,
    alpha: alpha,
    alphafi: alpha,
    menuIcon: menuIcon,
    closeIcon: closeIcon,
    redirectImage: redirectImage,
    redirectHover: redirectHover,
    alphalend: alphaLend,
    bluefin: bluefin,
    stsui: stsui,
    hasui: hasui,
    navi: navi,
    navx: navi, // NAVX token uses the same icon as NAVI
    suiusdt: suiusdt,
    bucket: bucket,
    wusdc: wusdc,
    cetus: cetus,
    usdc: usdc,
    eth: eth,
    btc: btc,
    wbtc: wbtcIcon, // wBTC (lowercase w) uses its specific icon
    WBTC: btc, // WBTC (uppercase) uses BTC icon
    usdt: usdt,
    suibtc: suibtc, // wBTC (lowercase w) uses its specific icon
    buck: bucket, // BUCK token uses bucket icon
    weth: eth, // WETH uses ETH icon
    afsui: afsui,
    alkimi: alkimi,
    esui: esui,
    ebtc: ebtc,
    xbtc: xbtc,
    xaum: xaum,
    up: up,
    wsol: wsol,
    deep: deep,
    fud: fud,
    ausd: ausd,
    ns: ns,
    blue: blue,
    send: send,
    vsui: vsui,
    musd: musd,
    lbtc: lbtc,
    dmc: dmc,
    ika: ika,
    tbtc: tbtc,
    sca: scallop,
    egusdc: egusdc,
    ethird: ethird,
    suieth: suieth,
    exbtc: exbtc,
    ewal: ewal,
    refreshIcon: refreshIcon,
    swapRefreshIcon: swapRefreshIcon,
    lockIcon: lockIcon,
    externalLinkIcon: externalLinkIcon,
    docsIcon: docsIcon,
    websiteIcon: websiteIcon,
    contractIcon: contractIcon,
    roundedGreenCheckIcon: roundedGreenCheckIcon,
    flagIcon: flagIcon,
    timeIcon: timeIcon,
    cancelIcon: cancelIcon,
    roundedGrayCheckIcon: roundedGrayCheckIcon,
    warningIcon: warningIcon,
    airdropModalCloseIcon: airdropModalCloseIcon,
    darkThemeSearchIcon: darkThemeSearchIcon,
    defaultThemeSearchIcon: defaultThemeSearchIcon,
    darkCloseIcon: darkCloseIcon,
    whiteCloseIcon: whiteCloseIcon,
    blackCloseIcon: blackCloseIcon,
    whiteReloadIcon: whiteReloadIcon,
    blackReloadIcon: blackReloadIcon,
    whiteSlippageIcon: whiteSlippageIcon,
    blackSlippageIcon: blackSlippageIcon,
    blackSwapIcon: blackSwapIcon,
    whiteSwapIcon: whiteSwapIcon,
    whiteSwapButton: whiteSwapButton,
    blackSwapButton: blackSwapButton,
    blackDownArrow: blackDownArrow,
    whiteDownArrow: whiteDownArrow,
    lightWalletIcon: lightWalletIcon,
    darkWalletIcon: darkWalletIcon,
    viceVersaIconWhite: viceVersaIconWhite,
    viceVersaIconBlack: viceVersaIconBlack,
    whiteBackIcon: whiteBackIcon,
    blackBackIcon: blackBackIcon,
    searchDark: searchDark,
    questionMarkIcon: questionMarkIcon,
    backWhiteIcon: backWhiteIcon,
    backWhiteMobileIcon: backWhiteMobileIcon,
    backBlackIcon: backBlackIcon,
    backBlackMobileIcon: backBlackMobileIcon,
    zapInIcon: zapInIcon,
    zapInIconDarkTheme: zapInIconDarkTheme,
    depositsIcon: depositsIcon,
    reverseTokensIcon: reverseTokensIcon,
    zapSlippageIcon: zapSlippageIcon,
    switchTokenIcon: switchTokenIcon,
    switchTokenDarkThemeIcon: switchTokenDarkThemeIcon,
    reverseTokensIconDarkTheme: reverseTokensIconDarkTheme,
    depositsIconForDarkTheme: depositsIconForDarkTheme,
    swapDesktopWhiteIcon: swapDesktopWhiteIcon,
    swapDesktopBlackIcon: swapDesktopBlackIcon,
    plusIcon: plusIcon,
    minusIcon: minusIcon,
    expandIcon: expandIcon,
    shrinkIcon: shrinkIcon,
    darkShrinkIcon: darkShrinkIcon,
    darkThemeExpandIcon: darkThemeExpandIcon,
    // Theme icons
    darkThemeCloseIcon: darkThemeCloseIcon,
    darkSun: darkSun,
    darkMoon: darkMoon,
    whiteSun: whiteSun,
    whiteMoon: whiteMoon,
    darkThreeDotIcon: darkThreeDotIcon,
    whiteThreeDotIcon: whiteThreeDotIcon,
    // Social media icons
    twitter: twitter,
    telegram: telegram,
    medium: medium,
    whiteTwitter: whiteTwitter,
    whiteTelegram: whiteTelegram,
    whiteTelegramIcon: whiteTelegramIcon,
    whiteMedium: whiteMedium,
    darkThemeTwitter: darkThemeTwitter,
    darkThemeTelegram: darkThemeTelegram,
    darkThemeMedium: darkThemeMedium,
    twitterHoverFooter: twitterHoverFooter,
    telegramHoverFooter: telegramHoverFooter,
    mediumHoverFooter: mediumHoverFooter,
    discordHoverFooter: discordHoverFooter,
    twitterFooter: twitterFooter,
    telegramFooter: telegramFooter,
    mediumFooter: mediumFooter,
    discordFooter: discordFooter,
    movebitIcon: movebitIcon,
    zeroShadowIcon: zeroShadowIcon,
    // Navigation icons
    darkThemeRightArrow: darkThemeRightArrow,
    upArrowBlack: upArrowBlack,
    downArrowBlack: downArrowBlack,
    defaultArrow: defaultArrow,
    defaultArrowDown: defaultArrowDown,
    externalIconDark: externalIconDark,
    externalIconWhite: externalIconWhite,
    externalIcon: externalIcon,
    externalIconHover: externalIconHover,
    // Wallet icons
    addressCopyIcon: addressCopyIcon,
    addressExternalLink: addressExternalLink,
    disconnectWalletIcon: disconnectWalletIcon,
    walletIcon: walletIcon,
    walletUpArrow: walletUpArrow,
    walletDownArrow: walletDownArrow,
    addressCopyIconHover: addressCopyIconHover,
    disconnectFilledIcon: disconnectFilledIcon,
    // Arrow icons
    rightArrow: rightArrow,
    downArrow: downArrow,
    darkThemeDefaultArrow: darkThemeDefaultArrow,
    darkThemeDownArrow: darkThemeDownArrow,
    darkThemeUpArrow: darkThemeUpArrow,
    searchIcon: searchIcon,
    clearSearchIcon: clearSearchIcon,
    rightArrowWhite: rightArrowWhite,
    swapIcon: swapIcon,
    questionMark: questionMark,
    // Additional icons
    closeIconSvg: closeIconSvg,
    menuIconSvg: menuIconSvg,
    slippageIcon: slippageIcon,
    secondaryCopyIcon: secondaryCopyIcon,
    // Notification icons
    success: success,
    failed: failed,
    // Aliases for compatibility
    close: closeIconSvg,
    rightArrowIcon: rightArrow,
    WhiteTwitterIcon: whiteTwitter,
    WhiteTelegramIcon: whiteTelegram,
    whiteTelegramFooterIcon: whiteTelegramIcon,
    WhiteMediumIcon: whiteMedium,
    wallet_icon: walletIcon,
    disconnect: disconnectWalletIcon,
    copy: addressCopyIcon,
    externalLink: addressExternalLink,
    // UI-kit specific mappings (note the typos in the original UI-kit code)
    adressCopyIcon: addressCopyIcon,
    adressExternalLinkIcon: addressExternalLink,
    alphafiLogo: alphafiLogo,
    alphafiLogoWhite: alphafiLogoWhite,
    alphaIconForLightTheme: alphaIconForLightTheme,
    // Additional aliases for compatibility
    wallet: walletIcon,
    darkCrossIcon: darkThemeCloseIcon,
    // UI-kit compatibility mappings
    logout: disconnectWalletIcon,
    whiteMenu: whiteMenuIcon,
    blackMenu: blackMenuIcon,
    whiteExternalLinkIcon: whiteExternalLinkIcon,
    blackExternalLinkIcon: blackExternalLinkIcon,
    whiteHeaderDownArrowIcon: whiteHeaderDownArrowIcon,
    whiteCopyIcon: whiteCopyIcon,
    infoIcon: infoIcon,
    websiteWhite: websiteWhite,
    contractWhite: contractWhite,
    docsWhite: docsWhite,
    whiteRefreshIcon: whiteRefreshIcon,
};
const symbolRemap = {
    wbtc: 'btc',
};
export const getIcon = (name, symbol) => {
    var _a;
    const icon = iconMap[name];
    if (!icon) {
        return questionMark;
    }
    if (symbol) {
        const remapped = symbolRemap[symbol];
        if (remapped) {
            return iconMap[remapped];
        }
        return (_a = iconMap[symbol]) !== null && _a !== void 0 ? _a : icon;
    }
    return icon;
};
